import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileFallback = ({ analytics, image, title, URL }) => {
   return (
      <a
         href={URL}
         class="tuile-fallback"
         {...attributesAnalytics(analytics)}
      >
         <div class="img-container">
            <img class="img" src={image} alt="" />
         </div>
         <h3 class="lead title">{title}</h3>
      </a>
   )
}
